var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"radar-wrapper"}},[_c('RadarChart',{ref:"radarChart",attrs:{"chartData":_vm.chartData},on:{"startupLogoClick":_vm.startupLogoClick}}),_c('StartupDetailsPopover',{ref:"startupDetailsPopover",attrs:{"target":_vm.popoverTarget}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }